<app-modal #internalModal [modalConfig]="modalConfig">
  <button
    class="btn btn-closemodal"
    title="Close"
    aria-label="close"
    headerContent
    (click)="closeModal()">
    <i class="bi bi-x-lg text-white"></i>
  </button>

  <div *ngIf="sessionType && info" class="preview-content">
    <img class="preview-thumbnail" [src]="thumbnailUrl" alt="" />

    <p class="layout-description">{{ layoutDescription }}</p>

    <p class="mb-1 fw-semibold">{{ info.summary }}</p>
    <p class="mb-3 fst-italic text-muted">e.g. {{ info.example }}</p>

    <p class="mb-1 fw-bold text-uppercase key-reports-label">Key Reports</p>
    <ul class="mb-0 key-reports-list">
      <li *ngFor="let report of info.reports">{{ report }}</li>
    </ul>
  </div>

  <div class="w-100 d-flex justify-content-end" footerContent>
    <button (click)="closeModal()" class="btn btn-reset" type="button">
      Close
    </button>
  </div>
</app-modal>
